<div class="phone-update-container">
   <div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
      <div class="toast-content">
        <div class="toast-text">
          <div class="toast-message-text">{{ toastMessage }}</div>
        </div>
        <span class="material-symbols-outlined f-24 p-0 cursor-pointer" 
        id="btn_phone_update_close_toast"
        (click)="closeToast()"
        (keypress)="closeToast()"
        *ngIf="toastType === 'success' || toastType === 'error'" 
        title="Close">close</span>
      </div>
    
      
    </div>
  </div>
  <div class="form-wrapper">
    <div class="header mt-4">
      <div class="row justify-content-center mt-2 mb-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img id="img_phone_update_edu_logo" src="assets/images/edu-logo.svg" alt="{{genericMessage['G0001']}}" class="img-fluid" />
            </div>
        </div>
    </div>

    <div class="horizontal-line"></div>

    <div class="form-container">
      <h2>Update Phone Number</h2>
      
      <form [formGroup]="phoneForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
              <label for="input_phone_update_phone_number">Enter New Phone Number<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="input_phone_update_phone_number"
                formControlName="phoneNumber"
                class="form-control"
                placeholder="Enter Phone Number"
                tabindex="0"
                (input)="formatPhoneNumber($event)"
                [ngClass]="{'is-invalid': isPhoneNumberInvalid}" 
              />
              
                <div id="error_phone_update_phone_number" *ngIf="isPhoneNumberInvalid" class="text-danger err-font">
                  {{ errorMessage }}
                </div>

            </div>

        <div class="button-container d-flex justify-content-between">
          <button 
            type="button"
            class="cancel-btn btn me-3" 
            id="btn_phone_update_cancel"
            (click)="onCancel()"
          >Cancel
          </button>
          <button 
            type="submit"
            class="submit-btn" 
            id="btn_phone_update_submit"
            [disabled]="isSubmitButtonDisabled" 
            [ngClass]="{'submit-btn-disabled': isSubmitButtonDisabled}"
          >
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
